import React from "react"
import { AspectRatio, AspectRatioProps, ImageProps } from "@chakra-ui/react"
import Image from "@app/components/Image/Image"
import useLearnPage from "@app/hooks/useLearnPage"

export interface LearnPageImageRatioProps {
  aspectRatioProps?: AspectRatioProps
  imageProps?: ImageProps
}

const LearnPageImageRatio = ({ aspectRatioProps, imageProps }: LearnPageImageRatioProps) => {
  const { item } = useLearnPage()

  return item.image ? (
    <AspectRatio ratio={158 / 133} w="full" {...aspectRatioProps}>
      <Image {...item.image} objectFit="cover" borderRadius="sm" {...imageProps} />
    </AspectRatio>
  ) : (
    <></>
  )
}

export default LearnPageImageRatio
